import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  i: PropTypes.number.isRequired,
  moveDot: PropTypes.func.isRequired,
  dotRadius: PropTypes.number,

  styles: PropTypes.object,
}

const defaultProps = {
  dotRadius: 5,
};

export default class Dot extends React.Component {
  onMouseDown = () => {
    console.log("onMouseDown");
    this.props.moveDot(this.props.i);
  }

  onMouseDownDelete = () => {
    console.log("onClick");
    this.props.deleteDot(this.props.i);
  }

  render() {
    const { x, y, styles, dotRadius } = this.props;
    return (
      <div
        className="react-image-dot"
        onMouseDown={this.onMouseDownDelete}
        style={{
          ...styles,
          height: dotRadius * 2,
          width: dotRadius * 2,
          borderRadius: dotRadius,
          transform: `translate(${-dotRadius}, ${-dotRadius})`,
          top: y-dotRadius,
          left: x-dotRadius
        }}
      />
    );
  }
}

Dot.propTypes = propTypes;
Dot.defaultProps = defaultProps;
